import React, { useCallback, useEffect, useState } from 'react'
import { CAlert, CButton } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilReload, cilWarning } from '@coreui/icons'
import CommonService from 'src/service/CommonService'
import BrandForm from './BrandForm'
import PartnerVisibility from './PartnerVisibility'
import './Branding.css'

const Branding = () => {
  const [brandingDetail, setBrandingDetail] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [showPosBased, setShowPosBased] = useState(0)

  const loadBranding = useCallback(() => {
    setLoading(true)
    setError(false)
    CommonService.branding()
      .then((res) => {
        if (res.status === 200) {
          setBrandingDetail(res.data || {})
          setShowPosBased(res.data?.is_show ? 1 : 0)
        } else {
          setError(true)
        }
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    loadBranding()
  }, [loadBranding])

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Branding</h1>
        <p className="ge-page-subtitle">
          Your club&apos;s public profile - name, links, logo and about copy shown to members.
        </p>
      </div>

      {error && (
        <CAlert color="danger" className="d-flex flex-wrap align-items-center gap-2">
          <CIcon icon={cilWarning} className="flex-shrink-0" />
          <span>We couldn&apos;t load your branding details. Nothing has been changed.</span>
          <CButton
            color="danger"
            variant="outline"
            size="sm"
            className="ms-auto"
            onClick={loadBranding}
          >
            <CIcon icon={cilReload} className="me-1" />
            Retry
          </CButton>
        </CAlert>
      )}

      <BrandForm
        brandingDetail={brandingDetail}
        loading={loading}
        showPosBased={showPosBased}
        onSaved={loadBranding}
        onDeleted={loadBranding}
      />

      <PartnerVisibility showPosBased={showPosBased} setShowPosBased={setShowPosBased} />
    </>
  )
}

export default Branding
